import axiosDefaultFinancial from "core/classes/axiosDefaultFinancial";
import { Plan } from "core/interfaces/plan.interface";
import { IPaymentCardLicitem } from "./efi.service";
import { LTMTransactionStatus } from "core/enums/transaction";

interface ITokenize {
    card_number: string;
}

interface ISubscription {
  supplierId: string;
  planId: string;
  paymentMethod: string;
}


interface IPaymentTransactionResponse {
  installmentId: string;
  amount: number;
  paymentStatus:  LTMTransactionStatus;
  paymentMethod: "credit_card" | "debit_card" | "paypal" | string; // Expanda conforme necessário
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  externalTransactionId: number;
}

export interface IPaymentTicketLicitem {
  planId: string;
  supplierId: string;
  installmentsNumber: number;
  isCnpjUsed: boolean;
  onDemandProcessCount?: number;
}

export interface IPaymentTicketLicitemResponse {
    installmentId: string;
    amount: number;
    paymentStatus:  LTMTransactionStatus; // Ex.: "waiting", "paid", etc.
    paymentMethod: string; // Ex.: "boleto", "credit_card", etc.
    _id: string;
    createdAt: string; // Pode ser alterado para Date, se necessário
    updatedAt: string; // Pode ser alterado para Date, se necessário
    __v: number;
    externalTransactionId: number;
    pixQrCode: string;
    pixQrCodeImage: string;
    pdf: string;
    dueDate: string; // Pode ser alterado para Date, se necessário  
}

export interface IPaymentPixResponse {
    installmentId: string;
    amount: number;
    paymentStatus: LTMTransactionStatus; // Pode ajustar os valores conforme sua lógica
    paymentMethod: "pix";
    _id: string;
    createdAt: string; // Ou use Date, se preferir
    updatedAt: string; // Ou use Date, se preferir
    __v: number;
    externalTransactionId: string;
    pixCopiaECola: string;
    dueDate: string; // Ou use Date, se preferir
}


export function GetPlans(): Promise<Plan[]> {
  return new Promise<Plan[]>(async (resolve, reject) => {
    try {
      const response = await axiosDefaultFinancial.get("plans?deletedAt=null");
      resolve(response.data);
    } catch (error: any) {
      reject(error?.data?.message);

    }
  });
}

export function Tokenize(cardNumber: ITokenize): Promise<any> {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosDefaultFinancial.post("cards/tokenize", cardNumber);
      resolve(response.data);
    } catch (error: any) {
      reject(error?.data?.error?.message || error.message);
    }
  });
}


export function CreateSubsriptions(data: ISubscription): Promise<any> {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosDefaultFinancial.post("subscriptions", data);
      resolve(response.data);
    } catch (error: any) {
      reject(error?.data?.message);

    }
  });
}

export function GetTransactionsById(idTransactions: string): Promise<IPaymentTransactionResponse> {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosDefaultFinancial.get(`transactions/${idTransactions}`);
      resolve(response.data);
    } catch (error: any) {
      reject(error?.data?.message);

    }
  });
}


export function PaymentCard(card: IPaymentCardLicitem): Promise<IPaymentTransactionResponse> {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosDefaultFinancial.post("transactions/efi/card", card);
      resolve(response.data);
    } catch (error: any) {
      reject(error?.data?.message);

    }
  });
}

export function CreateTicket(data: IPaymentTicketLicitem): Promise<IPaymentTicketLicitemResponse> {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosDefaultFinancial.post("transactions/efi/slip", data);
      resolve(response.data);
    } catch (error: any) {
      reject(error?.data?.message);

    }
  });
}

export function CreatePix(data: IPaymentTicketLicitem): Promise<IPaymentPixResponse> {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosDefaultFinancial.post("transactions/efi/pix", data);
      resolve(response.data);
    } catch (error: any) {
      reject(error?.data?.error?.message?.mensagem ?? error?.data?.message);
    }
  });
}
